<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") {{ title }}
          v-spacer
          v-btn.custom__padding-btn.mr-3(@click="$router.push('/users')" class="elevation-0") Back
          v-btn.custom__padding-btn(
            dark,
            color="blue-secondary",
            @click="createNewBU()"
            class="elevation-0"
          ) ADD NEW
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-select.hidden-sm-and-down.col-4.pl-0(
            label="Business Unit",
            :items="bisnis_unit",
            v-model="bisnisUnit",
            hide-details
          )
          span.pr-2
          v-select.hidden-sm-and-down.col-4.pl-0(
            label="Status",
            v-model="status",
            :items="dataStatus",
            hide-details
          )
          span.pr-2
          v-text-field.hidden-sm-and-down.col-4(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-2(
                title="edit",
                color="green",
                @click="onEdit(item.id)"
              )
                | edit

            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.

            template(v-slot:no-results)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "UsersBisnisUnitList",
  components: {},
  props: {
    title: String,
  },
  data() {
    return {
      keyword: "",
      bisnis_unit: ["All"],
      dataHeaders: [
        { text: "Alias Name", value: "alias" },
        { text: "Position", value: "position" },
        {
          text: "Business Unit",
          value: "business_unit.bu_name",
          filter: this.searchBisnisUnit,
        },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "msisdn" },
        { text: "Group", value: "group" },
        { text: "Status", value: "status", filter: this.statusFilter },
        { text: "Actions", value: "data-table-expand" },
      ],
      dataItems: [],
      bisnisUnit: "",
      dataStatus: ["All", "Active", "Non Active"],
      status: "",
    };
  },
  mounted() {
    this.getDataDetail();
  },
  methods: {
    getDataDetail() {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/users/${this.$route.params.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.data.bu.forEach((data) => {
            if (data.is_admin) {
              data.group = "Admin";
            } else {
              data.group = "User";
            }
            if (data.is_active) {
              data.status = "Active";
            } else {
              data.status = "Non Active";
            }
          });
          this.dataItems = res.data.data.bu;

          let bu = this.dataItems.map((val) => val.business_unit.bu_name);

          this.bisnis_unit = this.bisnis_unit.concat(bu);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
    onEdit(item) {
      this.$router.push(`/users/detail/${this.$route.params.id}/edit/` + item);
    },
    createNewBU() {
      this.$router.push(`/users/detail/${this.$route.params.id}/create?alias=${this.dataItems[0].alias}&mail=${this.dataItems[0].email}&phone=${this.dataItems[0].msisdn}&position=${this.dataItems[0].position}`);
    },
    searchBisnisUnit(val) {
      if (this.bisnisUnit == "All") {
        return true;
      }

      if (!this.bisnisUnit) {
        return true;
      }
      return val === this.bisnisUnit;
    },
    statusFilter(val) {
      if (this.status == "All") {
        return true;
      }

      if (!this.status) {
        return true;
      }
      return val === this.status;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>

